import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import InstructionIcon from '../../../../../../assets/svg/InstructionIcon';
import WarningIcon from '../../../../../../assets/svg/WarningIcon';
import { Stop } from '../../../../../../domain/stop/Stop';
import { Text } from '../../../../../../react-components/Text';
import { useRetrieveVehicle } from '../../../../hooks/useRetrieveVehicle';
import { StopDetailsField } from './StopDetailsField';

interface StopDetailsProps {
  stop: Stop;
}

export const StopDetails = ({ stop }: StopDetailsProps) => {
  const { data: vehicleData } = useRetrieveVehicle();

  if (!vehicleData?.project) return null;

  return (
    <>
      {stop.optimization_warning ? (
        <Grid
          key="customer_text_field"
          style={{
            margin: `0px 20px`,
            padding: `10px 0`,
            borderBottom: `0.5px solid ${RoutalPalette.grey9}`,
          }}
        >
          <Grid style={{ display: `flex`, flexDirection: `row`, alignItems: `center` }}>
            <WarningIcon
              color={RoutalPalette.error.medium}
              style={{ height: `15px`, width: `15px`, paddingRight: `5px` }}
            />
            <Text
              variant="label"
              style={{ color: RoutalPalette.error.medium }}
              intlId="driver.stop.entry.drivers_optimization_warning"
            />
          </Grid>
        </Grid>
      ) : null}
      {/* Instrucciones del cliente */}
      {stop.customer_text_field ? (
        <>
          <Grid
            key="customer_text_field"
            style={{
              margin: `0px 20px`,
              padding: `10px 0`,
              borderBottom: `0.5px solid ${RoutalPalette.grey9}`,
            }}
          >
            <Grid style={{ display: `flex`, flexDirection: `row`, alignItems: `center` }}>
              <InstructionIcon
                style={{ height: `15px`, width: `15px`, paddingRight: `5px`, color: RoutalPalette.warning.medium }}
              />
              <Text
                variant="label"
                style={{ color: RoutalPalette.warning.medium }}
                intlId="driver.stop.entry.customer_text_field"
              />
            </Grid>
            <VSpacer small />
            <Text variant="body">{stop.customer_text_field}</Text>
          </Grid>
          <VSpacer small />
        </>
      ) : null}

      {/* Detalles de parada especiales*/}
      {stop.stop_fields && stop.stop_fields.length > 0 && (
        <>
          {stop.stop_fields.map((stopField, i) => {
            if (Array.isArray(stopField.value) && stopField.value.length === 0) {
              return null;
            }
            return stopField.type != null && stopField.id != null ? (
              <StopDetailsField key={i} stopField={stopField} project={vehicleData.project} />
            ) : null;
          })}
        </>
      )}
      <VSpacer small />
    </>
  );
};
